import { setStatus } from 'shared/common/slices/modalFormSlice';
import { EStatus } from 'shared/common/types/form';
import { TThunk } from 'shared/common/types/thunk';

export const setModalInit = (): TThunk => dispatch => {
  dispatch(setStatus(EStatus.Initial));
};
